export const permissions = {
  CUSTOMERS_ADD: 'CUSTOMERS_ADD',
  CUSTOMERS_DELETE: 'CUSTOMERS_DELETE',
  CUSTOMERS_EDIT: 'CUSTOMERS_EDIT',
  CUSTOMERS_READ: 'CUSTOMERS_READ',
  CUSTOMERS_ACCESS: 'CUSTOMERS_ACCESS',
  CUSTOMERS_MERGE: 'CUSTOMERS_MERGE',

  CLIENTS_ADD: 'CLIENTS_ADD',
  CLIENTS_DELETE: 'CLIENTS_DELETE',
  CLIENTS_EDIT: 'CLIENTS_EDIT',
  CLIENTS_READ: 'CLIENTS_READ',

  COMPANIES_ADD: 'COMPANIES_ADD',
  COMPANIES_DELETE: 'COMPANIES_DELETE',
  COMPANIES_EDIT: 'COMPANIES_EDIT',
  COMPANIES_READ: 'COMPANIES_READ',
  COMPANIES_ACCESS: 'COMPANIES_ACCESS',

  DASHBOARD_READ: 'DASHBOARD_READ',
  MANAGE_ACCESS_RIGHTS: 'MANAGE_ACCESS_RIGHTS',
  FILE_EXPORT_READ: 'FILE_EXPORT_READ',

  PERMISSION_READ: 'PERMISSION_READ',

  PROFILE_EDIT: 'PROFILE_EDIT',
  PROFILE_READ: 'PROFILE_READ',

  ROLES_ADD: 'ROLES_ADD',
  ROLES_DELETE: 'ROLES_DELETE',
  ROLES_EDIT: 'ROLES_EDIT',
  ROLES_READ: 'ROLES_READ',

  TRANSACTIONS_READ: 'TRANSACTIONS_READ',
  TRANSACTIONS_RESEND: 'TRANSACTIONS_RESEND',
  TRANSACTIONS_INVENTORY_DOWNLOAD: 'TRANSACTIONS_INVENTORY_DOWNLOAD',
  INVENTORY_UPLOAD: 'INVENTORY_UPLOAD',
  INVENTORY_UPLOAD_HISTORY_READ: 'INVENTORY_UPLOAD_HISTORY_READ',

  PO_APPROVE_CHANGE: 'PO_APPROVE_CHANGE',

  USERS_ADD: 'USERS_ADD',
  USERS_DELETE: 'USERS_DELETE',
  USERS_EDIT: 'USERS_EDIT',
  USERS_READ: 'USERS_READ',
  USERS_REGISTER: 'USERS_REGISTER',

  SUBORDINATE_USER_READ: 'SUBORDINATE_USER_READ',
  SUBORDINATE_USER_ADD: 'SUBORDINATE_USER_ADD',
  SUBORDINATE_USER_EDIT: 'SUBORDINATE_USER_EDIT',

  CHANGE_PASSWORD: 'CHANGE_PASSWORD',
  ADMIN_CHANGE_PASSWORD: 'ADMIN_CHANGE_PASSWORD',
  EXPORT_LAST_LOGGED: 'EXPORT_LAST_LOGGED',

  VENDORS_ADD: 'VENDORS_ADD',
  VENDORS_DELETE: 'VENDORS_DELETE',
  VENDORS_EDIT: 'VENDORS_EDIT',
  VENDORS_READ: 'VENDORS_READ',
  VENDORS_ACCESS: 'VENDORS_ACCESS',
  VENDORS_MERGE: 'VENDORS_MERGE',

  RIGHTS_READ: 'RIGHTS_READ',
  RIGHTS_ADD: 'RIGHTS_ADD',
  RIGHTS_EDIT: 'RIGHTS_EDIT',
  RIGHTS_DELETE: 'RIGHTS_DELETE',
  IMPORT_DATA: 'IMPORT_DATA',

  EDI_TYPE_SYNCH: 'EDI_TYPE_SYNCH',
  EDI_TYPE_READ: 'EDI_TYPE_READ',
  EDI_TYPE_EDIT: 'EDI_TYPE_EDIT',

  IMPORT_HISTORY_READ: 'IMPORT_HISTORY_READ',

  VIEW_PRICING_INFO: 'VIEW_PRICING_INFO',

  CONSOLE_APPLICATIONS_CREATE: 'CONSOLE_APPLICATIONS_CREATE',
  CONSOLE_APPLICATIONS_DELETE: 'CONSOLE_APPLICATIONS_DELETE',
  CONSOLE_APPLICATIONS_EDIT: 'CONSOLE_APPLICATIONS_EDIT',
  CONSOLE_APPLICATIONS_READ: 'CONSOLE_APPLICATIONS_READ',

  PURCHASE_ORDER_READ: 'PURCHASE_ORDER_READ',
  PURCHASE_ORDER_ADD: 'PURCHASE_ORDER_ADD',
  PURCHASE_ORDER_EDIT: 'PURCHASE_ORDER_EDIT',
  PURCHASE_ORDER_DELETE: 'PURCHASE_ORDER_DELETE',
  PURCHASE_ORDER_CONFIRM: 'PURCHASE_ORDER_CONFIRM',
  PURCHASE_ORDER_REJECT: 'PURCHASE_ORDER_REJECT',
  PURCHASE_ORDER_RESEND: 'PURCHASE_ORDER_RESEND',
  PURCHASE_ORDER_IMPORT_DATA: 'PURCHASE_ORDER_IMPORT_DATA',
  PURCHASE_ORDER_EXPORT_DATA: 'PURCHASE_ORDER_EXPORT_DATA',

  SHIPMENTS_READ: 'SHIPMENTS_READ',
  SHIPMENTS_ADD: 'SHIPMENTS_ADD',
  SHIPMENTS_EDIT: 'SHIPMENTS_EDIT',
  SHIPMENTS_DELETE: 'SHIPMENTS_DELETE',

  INVOICING_READ: 'INVOICING_READ',
  INVOICING_ADD: 'INVOICING_ADD',
  INVOICING_EDIT: 'INVOICING_EDIT',
  INVOICING_DELETE: 'INVOICING_DELETE',

  OES_WORKSPACE: 'OES_WORKSPACE',

  OES_MASTER_DATA: 'OES_MASTER_DATA',
  OES_MASTER_DATA_ADD: 'OES_MASTER_DATA_ADD',
  OES_MASTER_DATA_EDIT: 'OES_MASTER_DATA_EDIT',
  OES_MASTER_DATA_DELETE: 'OES_MASTER_DATA_DELETE',
  OES_MASTER_DATA_EXPORT: 'OES_MASTER_DATA_EXPORT',
  OES_MASTER_DATA_IMPORT: 'OES_MASTER_DATA_IMPORT',

  OES_RACK: 'OES_RACK',
  OES_RACK_ADD: 'OES_RACK_ADD',
  OES_RACK_EDIT: 'OES_RACK_EDIT',
  OES_RACK_DELETE: 'OES_RACK_DELETE',

  OES_PLANTS: 'OES_PLANTS',
  OES_PLANTS_ADD: 'OES_PLANTS_ADD',
  OES_PLANTS_EDIT: 'OES_PLANTS_EDIT',
  OES_PLANTS_DELETE: 'OES_PLANTS_DELETE',

  OES_SCANNED_DATA: 'OES_SCANNED_DATA',
  OES_SCANNED_DATA_EDIT: 'OES_SCANNED_DATA_EDIT',
  OES_SCANNED_DATA_DELETE: 'OES_SCANNED_DATA_DELETE',
  OES_SCANNED_DATA_EXPORT: 'OES_SCANNED_DATA_EXPORT',
  OES_SCANNED_DATA_RESEND: 'OES_SCANNED_DATA_RESEND',

  OES_VIEW_REPLENISHMENT_SCANS: 'OES_VIEW_REPLENISHMENT_SCANS',
  OES_SAVED_DATA_READ: 'OES_SAVED_DATA_READ',
  OES_SAVED_DATA_ADD: 'OES_SAVED_DATA_ADD',
  OES_SAVED_DATA_EDIT: 'OES_SAVED_DATA_EDIT',
  OES_SAVED_DATA_DELETE: 'OES_SAVED_DATA_DELETE',
  OES_SAVED_DATA_EXPORT: 'OES_SAVED_DATA_EXPORT',

  OES_MASTER_CUSTOMER_READ: 'OES_MASTER_CUSTOMER_READ',
  OES_MASTER_CUSTOMER_ADD: 'OES_MASTER_CUSTOMER_ADD',
  OES_MASTER_CUSTOMER_EDIT: 'OES_MASTER_CUSTOMER_EDIT',
  OES_MASTER_CUSTOMER_DELETE: 'OES_MASTER_CUSTOMER_DELETE',

  OES_USAGE_REPORT: 'OES_USAGE_REPORT',

  EDI_MAINT_VIEW: 'EDI_MAINT_VIEW',
  EDI_MAINT_EDIT: 'EDI_MAINT_EDIT',
  EDI_MAINT_EDIT_TOKEN: 'EDI_MAINT_EDIT_TOKEN', // Just for access by TP token logic

  COMPARATIO_EMP: 'COMPARATIO_EMP',
  ADMIN: 'ADMIN',
  EDI_TRADING_PARTNER_ADD: 'EDI_TRADING_PARTNER_ADD',

  ZO1_VIEW_INVENTORY : 'ZO1_VIEW_INVENTORY',
  ZO1_ADD_INVENTORY : 'ZO1_ADD_INVENTORY',
  ZO1_EDIT_INVENTORY : 'ZO1_EDIT_INVENTORY',
  ZO1_DELETE_INVENTORY : 'ZO1_DELETE_INVENTORY',

  ADMINISTRATION_ACCESS : 'ADMINISTRATION_ACCESS',
  COMPANY_MAPPING_VIEW : 'COMPANY_MAPPING_VIEW',
  COMPANY_MAPPING_EDIT : 'COMPANY_MAPPING_EDIT',
  ADMIN_REPORTS_VIEW : 'ADMIN_REPORTS_VIEW',
  KPI_METRICS : 'KPI_METRICS',
};



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/permissions.ts